<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'

  export default {
    data() {
      return {
          feedid: this.$f7route.params.feedid
      }
    },
    computed: {
      ...mapGetters([
          'RssFeedData',
          'MainMenuLayout'
      ]),
      RssFeedList() {
        return this.RssFeedData ? this.RssFeedData.Items : []
      },
      RssFeedDetails() {
        return this.RssFeedData ? this.RssFeedList[this.feedid] : null
      },
      PageTitle() {
        return this.RssFeedDetails ? this.RssFeedDetails.Title.Text : ''
      }
    },
    methods: {
      formattedDate: function(value) {
        return Helper.FormattedDateDDMMMMYY(value)
      },
      url(value){
        window.open(value)
      },
      isNullOrEmpty: function(value) {
          return Helper.IsNullOrEmpty(value)
      }
    }
  }
</script>
<template>
  <f7-page ref="rssFeedPage" :page-content="false" name="rss-detail-view">
    <!-- Header View Component -->
    <app-header :header="PageTitle" :isShowRightNavBar="false"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <!-- Menu View Component  -->
    <div class="backgroundimg"></div>
    <f7-page-content v-if="RssFeedDetails">
      <f7-card>
        <f7-card-header class="card_Title">{{RssFeedDetails.Title.Text}}</f7-card-header>
          <f7-card-content>
            <div>{{formattedDate(RssFeedDetails.PublishDate)}}</div><br>
            <div v-html="RssFeedDetails.Summary.Text"></div><br>
            
          </f7-card-content>
          <f7-card-footer>
            <a @click="url(RssFeedDetails.Id)">Read More...</a>
          </f7-card-footer>
      </f7-card>
    </f7-page-content>
  </f7-page>
</template>
<style>
.card_Title {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/rssFeed/RssFeedDetail.vue